export const HIT_OKR_LIST = 'HIT_OKR_LIST';
export const GET_OKR_LIST = 'GET_OKR_LIST';

export const HIT_ADD_OKR = 'HIT_ADD_OKR';
export const HIT_EDIT_OKR = 'HIT_EDIT_OKR';

export const HIT_OKR_DETAIL = 'HIT_OKR_DETAIL';
export const GET_OKR_DETAIL = 'GET_OKR_DETAIL';

export const HIT_OKR_RESPONSE = 'HIT_OKR_RESPONSE';
export const GET_OKR_RESPONSE = 'GET_OKR_RESPONSE';

export const HIT_ADD_ASSIGNMENT = 'HIT_ADD_ASSIGNMENT';
export const HIT_PT_DEL_ASSIGNMENT = 'HIT_PT_DEL_ASSIGNMENT';

export const HIT_PT_COMMENT = 'HIT_PT_COMMENT';

export const HIT_LIST_MEASURENMENT = 'HIT_LIST_MEASURENMENT';
export const GET_LIST_MEASURENMENT = 'GET_LIST_MEASURENMENT';

export const HIT_LIST_PROCESS = 'HIT_LIST_PROCESS';
export const GET_LIST_PROCESS = 'GET_LIST_PROCESS';

export const HIT_PT_OBJECTIVE_LIST = 'HIT_PT_OBJECTIVE_LIST';
export const HIT_PT_KEYRESULT_LIST = 'HIT_PT_KEYRESULT_LIST';
export const HIT_PT_INITIATIVE_LIST = 'HIT_PT_INITIATIVE_LIST';

export const GET_PT_OBJECTIVE_LIST = 'GET_PT_OBJECTIVE_LIST';
export const GET_PT_KEYRESULT_LIST = 'GET_PT_KEYRESULT_LIST';
export const GET_PT_INITIATIVE_LIST = 'GET_PT_INITIATIVE_LIST';

export const HIT_OKR_STATUS = 'HIT_OKR_STATUS';
export const GET_OKR_STATUS = 'GET_OKR_STATUS';

export const GET_PT_HIERARCHY = 'GET_PT_HIERARCHY';
export const HIT_PT_HIERARCHY = 'HIT_PT_HIERARCHY';

export const HIT_TEMPORARY_ASSIGNMENT = 'HIT_TEMPORARY_ASSIGNMENT';
export const GET_TEMPORARY_ASSIGNMENT = 'GET_TEMPORARY_ASSIGNMENT';

export const HIT_UPDATE_PROGRESS = 'HIT_UPDATE_PROGRESS';
export const GET_UPDATE_PROGRESS = 'GET_UPDATE_PROGRESS';

export const HIT_PT_OKR_DUPLICATE = 'HIT_PT_OKR_DUPLICATE';
export const HIT_PT_OKR_DELETE = 'HIT_PT_OKR_DELETE';
